import { Controller } from "@hotwired/stimulus"

// Honeypot timing controller (PB-18).
//
// Stamps a hidden field with the page-load timestamp (milliseconds since
// epoch) so the server can reject submissions posted faster than a human
// could reasonably fill out the form. Bots that auto-submit instantly will
// trip the trap; humans who take >2s pass through unaffected.
export default class extends Controller {
  static targets = ["loadedAt"]

  connect() {
    const t = Date.now()
    if (this.hasLoadedAtTarget) {
      this.loadedAtTarget.value = String(t)
    } else {
      this.element.value = String(t)
    }
  }
}
